var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Geography",
    transform: "translate(21464 -2570)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21464 2570)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_63",
    "data-name": "Union 63",
    d: "M11,61.465a1.5,1.5,0,0,1,0-3h7.768a1.991,1.991,0,0,1-.267-1V53.933A28.926,28.926,0,0,1,2.548,48.126l.031-.04a2.464,2.464,0,0,1-.429-.261,2.5,2.5,0,1,1,3.378-3.653l.031-.04A24,24,0,1,0,34.444,5.8l.031-.04A2.5,2.5,0,1,1,37.054,1.5a2.466,2.466,0,0,1,.369.34l.03-.04A28.972,28.972,0,0,1,43.16,42.418,28.908,28.908,0,0,1,24.037,53.683q-.769.108-1.537.175v3.607a1.99,1.99,0,0,1-.268,1H30a1.5,1.5,0,1,1,0,3ZM0,24.966a20,20,0,1,1,20,20A20,20,0,0,1,0,24.966Zm5.293-6.589c.8,1.187,2.033,3.013,2.789,4.124a9.284,9.284,0,0,0,1.457,1.673l.064.058a11.633,11.633,0,0,0,2.552,1.754c1.13.569,2.777,1.464,3.937,2.106a2.572,2.572,0,0,1,1.327,2.255v2.581a2.583,2.583,0,0,0,.755,1.825A6.032,6.032,0,0,1,20,38.886v2.209a16.107,16.107,0,0,0,3.44-.379l1.4-3.778c.165-.443.263-.9.385-1.36a1.925,1.925,0,0,1,.5-.864l.913-.91a3.752,3.752,0,0,0,1.106-2.66,2.459,2.459,0,0,0-.72-1.74l-1.1-1.1a2.58,2.58,0,0,0-1.824-.756H18.71c-.759-.38-1.732-2.58-2.58-2.58a5.461,5.461,0,0,1-2.444-.578l-.894-.446a.964.964,0,0,1,.126-1.777l2.514-.838a1.291,1.291,0,0,1,1.254.249l.749.651a.645.645,0,0,0,.423.157h.455a.645.645,0,0,0,.577-.933l-1.257-2.515a.645.645,0,0,1,.127-.751l.8-.778a.645.645,0,0,1,.45-.184h.725a.644.644,0,0,0,.456-.188l.645-.645a.646.646,0,0,0,0-.912l-.379-.379a.646.646,0,0,1,0-.912l.834-.834.378-.377a1.291,1.291,0,0,0,0-1.825L19.386,8.868a16.258,16.258,0,0,0-1.966.2v.912a1.29,1.29,0,0,1-1.868,1.154l-1.937-.968A16.215,16.215,0,0,0,5.293,18.377Zm28.07-.092a1.929,1.929,0,0,0-.745.657l-1.58,2.369a1.931,1.931,0,0,0,0,2.147l1.45,2.174a1.932,1.932,0,0,0,1.141.8l2.353.588a15.628,15.628,0,0,0-1.572-9.264Z",
    transform: "translate(-21439 2586.293)",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeography);
export default __webpack_public_path__ + "static/media/Geography.9c1fcfc9.svg";
export { ForwardRef as ReactComponent };